/**
 * @generated SignedSource<<a8276d76b38c08f56efa567948274149>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFavoritesItem_user$data = {
  readonly canShowFolder: boolean | null;
  readonly " $fragmentType": "useFavoritesItem_user";
};
export type useFavoritesItem_user$key = {
  readonly " $data"?: useFavoritesItem_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFavoritesItem_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowFolder",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "802e7f6659e21b0ee641bc7238d42dd7";

export default node;
